import GeoProjectsModule from "./GeoProjectsModule.js";
import UtilsModule from "./UtilsModule.js"

let geoProjects = null;
let utils = null;

(function($){
    $("document").ready(()=>{
        geoProjects = new GeoProjectsModule();
        utils = new UtilsModule();
    
        let customEv = new CustomEvent("swlri-geo-projects-modules-loaded")
        window.dispatchEvent(customEv);

    })
})(jQuery)

export {
    geoProjects,
    utils
};